import { ReactNode } from "react";
import Sidebar from "@/components/Sidebar";
import MobileBottomNav from "@/components/MobileBottomNav";

const AppShell = ({ children }: { children: ReactNode }) => (
  <div className="min-h-[calc(100vh-5rem)] bg-gray-50">
    <div className="max-w-5xl mx-auto px-3 sm:pl-2 sm:pr-4 py-4 md:py-6 pb-24 md:pb-6">
      <div className="flex flex-col md:flex-row gap-3 md:gap-5 md:items-start">
        <div className="hidden md:block">
          <Sidebar />
        </div>
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
    <MobileBottomNav />
  </div>
);

export default AppShell;
